import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { LineChart, ShieldCheck } from "lucide-react";

export function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const links = [
    { to: "/courses", label: "Courses" },
    { to: "/#how", label: "How It Works" },
    { to: "/faq", label: "FAQ" },
    { to: "/contact", label: "Contact" },
  ];
  return (
    <nav className="sticky top-0 z-50 backdrop-blur-xl bg-white/80 border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="nav-logo">
          <LineChart className="h-6 w-6 text-[#00B368]" />
          <span className="font-display text-lg tracking-tight text-[#0A1914]">Electronics&#8209;Galore<span className="text-[#00B368]">.com</span></span>
        </Link>
        <div className="hidden md:flex items-center gap-7">
          {links.map((l) => (
            <a key={l.to} href={l.to} className="text-sm text-gray-600 hover:text-[#0A1914] transition-colors" data-testid={`nav-${l.label.toLowerCase().replace(/ /g,'-')}`}>{l.label}</a>
          ))}
        </div>
        <div className="flex items-center gap-3">
          {user && user.role === "admin" && (
            <Link to="/admin" data-testid="nav-admin-link" className="flex items-center gap-1 text-sm font-semibold text-[#D4AF37] hover:text-[#0A1914] transition-colors">
              <ShieldCheck className="h-4 w-4" /> ADMIN
            </Link>
          )}
          {user ? (
            <>
              <Link to="/members" data-testid="nav-members" className="text-sm text-gray-600 hover:text-[#0A1914] transition-colors">Members</Link>
              <button onClick={async () => { await logout(); navigate("/"); }} data-testid="nav-logout" className="text-sm border border-[#0A1914] px-4 py-1.5 rounded-sm hover:bg-[#F3F4F3] transition-colors">Log out</button>
            </>
          ) : (
            <>
              <Link to="/login" data-testid="nav-login" className="text-sm text-gray-600 hover:text-[#0A1914] transition-colors">Log in</Link>
              <Link to="/register" data-testid="nav-register" className="text-sm bg-[#0A1914] text-white px-4 py-1.5 rounded-sm hover:bg-[#00B368] transition-colors">Get Started</Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}
